/**
 * @fileoverview Página principal de Empresas — wrapper de página que monta o
 * gerenciador `CompaniesByGroup` dentro do shell padrão (`MainContainer`).
 *
 * A regra de negócio (listagem, criação, edição, contas, usuários, permissões)
 * vive em `components/CompaniesManager/CompaniesByGroup.js`. Aqui só damos a
 * casca de página com background atmosférico do tema dark e scroll de página.
 */

import React from "react";
import MainContainer from "../../components/MainContainer";
import CompaniesByGroup from "../../components/CompaniesManager/CompaniesByGroup";

const Companies = () => (
  <MainContainer>
    <CompaniesByGroup />
  </MainContainer>
);

export default Companies;
